const CurrencyOfferModel = {};

CurrencyOfferModel.STATUSES = {
  DRAFT: 1,
  ACTIVE: 2,
  NOT_ACTIVE: 3,
  NEED_DETAILS: 4,
  ON_REVIEW: 5,
  SOLD: 6,
  TRANSFERRED: 7,
  REVIEW_PASSED: 8,
};

CurrencyOfferModel.STATUS_ID_TO_DATA = {
  [CurrencyOfferModel.STATUSES.DRAFT]: {
    name: 'Draft',
    color: '#475C7F',
    description: 'Offer is saved as draft and not visible to others.',
  },
  [CurrencyOfferModel.STATUSES.ACTIVE]: {
    name: 'Active',
    color: '#4EB80D',
    description: 'Offer is active and visible to customers.',
  },
  [CurrencyOfferModel.STATUSES.NOT_ACTIVE]: {
    name: 'Not active',
    color: '#475C7F',
    description: 'Offer is not active and not visible to customers.',
  },
  [CurrencyOfferModel.STATUSES.NEED_DETAILS]: {
    name: 'Need details',
    color: '#FF5E29',
    description: 'Offer has not passed the review and needs additional details.',
  },
  [CurrencyOfferModel.STATUSES.ON_REVIEW]: {
    name: 'On review',
    color: '#171E26',
    description: 'Offer is under review.',
  },
  [CurrencyOfferModel.STATUSES.SOLD]: {
    name: 'Sold',
    color: '#475C7F',
    description: 'There is an order for this offer. Check your orders.',
  },
  [CurrencyOfferModel.STATUSES.TRANSFERRED]: {
    name: 'Transferred',
    color: '#475C7F',
    description: 'The order for this offer has been completed.',
  },
  [CurrencyOfferModel.STATUSES.REVIEW_PASSED]: {
    name: 'Review passed',
    color: '#475C7F',
    description: 'Offer has passed the review and waiting for activation.',
  },
};

CurrencyOfferModel.ALLOWED_ADMIN_REVIEW_STATUS_CHANGES = [
  CurrencyOfferModel.STATUSES.NEED_DETAILS,
  CurrencyOfferModel.STATUSES.REVIEW_PASSED,
];

CurrencyOfferModel.ALLOWED_ADMIN_ACTIVE_STATUS_CHANGES = [
  CurrencyOfferModel.STATUSES.NEED_DETAILS,
  CurrencyOfferModel.STATUSES.NOT_ACTIVE,
];

CurrencyOfferModel.ALLOWED_ADMIN_NOT_ACTIVE_STATUS_CHANGES = [
  CurrencyOfferModel.STATUSES.NEED_DETAILS,
  CurrencyOfferModel.STATUSES.ACTIVE,
];

CurrencyOfferModel.RESTRICTED_STATUSES_TO_CHANGE = [
  CurrencyOfferModel.STATUSES.SOLD,
  CurrencyOfferModel.STATUSES.TRANSFERRED,
];

CurrencyOfferModel.TYPES = {
  GOLD: 1,
  ACCOUNT: 2,
};

// Завел модель на будущее для функционала смурфов
CurrencyOfferModel.CREDENTIALS_FIELDS = {
  EMAIL: 'email',
  EMAIL_PASSWORD: 'email_password',
  LOGIN: 'login',
  GAME_PASSWORD: 'game_password',
  IS_2FA_ACTIVE: 'is_2fa_active',
  COMMENT: 'comment',
};

CurrencyOfferModel.CREDENTIALS_FIELDS_DATA = {
  [CurrencyOfferModel.CREDENTIALS_FIELDS.EMAIL]: {
    label: 'Registration email',
  },
  [CurrencyOfferModel.CREDENTIALS_FIELDS.EMAIL_PASSWORD]: {
    label: 'Email password',
  },
  [CurrencyOfferModel.CREDENTIALS_FIELDS.LOGIN]: {
    label: 'Account login',
  },
  [CurrencyOfferModel.CREDENTIALS_FIELDS.GAME_PASSWORD]: {
    label: 'Account password',
  },
  [CurrencyOfferModel.CREDENTIALS_FIELDS.IS_2FA_ACTIVE]: {
    label: '2FA',
  },
  [CurrencyOfferModel.CREDENTIALS_FIELDS.COMMENT]: {
    label: 'Comment from seller',
  },
};

CurrencyOfferModel.IMPORT_STATUSES = {
  WAITING: 1,
  IN_PROGRESS: 2,
  ERROR: 3,
};

export default CurrencyOfferModel;
